/* eslint-disable @next/next/no-img-element */
import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { SupportArticle } from '@/data/support'

import Link from 'next/link'

import { Layout, Seo, PageHero } from '@/components/generals'
import { SupportNav } from '@/components/support'
import { routes } from '@/lib/routes'
import { getSupportArticles } from '@/data/support'

type SupportPageProps = {
    articles: SupportArticle[]
}

const SupportPage: FC<SupportPageProps> = ({ articles }): ReactNode => {
    return (
        <Layout>
            <Seo title='Support' description='Help and support for San Diego. Read the most common questions and answers.' />

            <PageHero
                badge='New'
                eyebrow='Introducing the Class app'
                eyebrowHref='/features'
                title={
                    <>
                        Help &amp; <span className='text-gradient'>support</span>
                    </>
                }
                description='San Diego keeps your work on-brand, on message, and on time. Find answers fast and get back to what matters.'
                showButtons
            />

            <div className='section'>
                <div className='container'>
                    <div className='support-grid-layout animation-on-page-load'>
                        <SupportNav articles={articles} showSearch id='w-node-ed754a59-142e-5306-6934-ed458e9b3ad5-77af58b0' />

                        <div id='w-node-ed754a59-142e-5306-6934-ed458e9b3aed-77af58b0' className='support-article-holder'>
                            <div className='small-container'>
                                <div className='text-center'>
                                    <img
                                        src='/images/Logo-About.png'
                                        loading='lazy'
                                        sizes='(max-width: 479px) 72vw, (max-width: 767px) 36vw, 200px'
                                        srcSet='/images/Logo-About-p-500.png 500w, /images/Logo-About-p-800.png 800w, /images/Logo-About.png 956w'
                                        alt='San Diego'
                                        className='support-app-icon'
                                    />
                                    <h2 className='heading-3-style'>
                                        Support <span className='text-gradient'>Center</span>
                                    </h2>
                                    <div className='w-layout-grid grid-10-columns'>
                                        <p className='grey-text'>
                                            <strong>
                                                <em>Welcome</em>
                                            </strong>{' '}
                                            to the San Diego help center. How can we help you? Read about the most common questions
                                            and answers.
                                            <br />
                                            <a href='mailto:hello@sandiego.app'>hello@sandiego.app</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id='w-node-ed754a59-142e-5306-6934-ed458e9b3ae4-77af58b0' className='support-cta-holder'>
                            <h2 className='card-title-sm'>
                                Not finding what you&apos;re
                                <br />
                                looking for ?
                            </h2>
                            <p className='grey-text'>Our team is here to help. Reach out and we will get back to you quickly.</p>
                            <Link href={routes.contact} className='button w-button'>
                                Contact us
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<SupportPageProps> = async () => {
    return { props: { articles: await getSupportArticles() }, revalidate: 60 }
}

export default SupportPage
